import React from 'react';
import { Tag } from '@ontruck/orc';

import { injectIntl } from 'react-intl';

const feedbackSkin = {
  PENDING_ASSIGNMENT: 'modernRed',
  ASSIGNED: 'priority',
  IN_TRANSIT: 'priority',
  DONE: 'priority',
  DONE_WITHOUT_MANIFEST: 'priority',
  DONE_WITH_CANCELLATIONS: 'priority',
  CANCELLED: 'modernRed',
};

const OrderStatus = ({ status, intl }) => {
  const t = intl.messages.modules.order_statuses;
  const statuses = {
    PENDING_MODERATION: t.queued,
    PENDING_ASSIGNMENT: t.unassigned,
    ASSIGNED: t.assigned,
    IN_TRANSIT: t.assigned,
    DONE: t.finished,
    DONE_WITHOUT_MANIFEST: t.finished,
    DONE_WITH_CANCELLATIONS: t.finished,
    CANCELLED: t.cancelled,
  };
  return (
    <Tag skin={feedbackSkin[status]} weight="bold">
      {statuses[status]}
    </Tag>
  );
};

export default injectIntl(OrderStatus);
